import { connectedStore } from '../../../store';
import getPages from '../../../site/selectors/pages';

const isCustomColorUsed = (textColorCssVariable) => {
  const store = connectedStore.get();
  const state = store.getState();

  const pages = getPages(state);
  const colorHash = textColorCssVariable.split('-').pop();

  return pages.some(
    (page) =>
      page.usedCustomColors &&
      page.usedCustomColors.some(
        (usedCustomColor) => colorHash === usedCustomColor.split('-').pop()
      )
  );
};

export default isCustomColorUsed;
